/**
 * Privacy Policy page
 */

import {LandingLayout} from '../../components/layout/LandingLayout';
import {Container} from '../../components/ui/Container';
import {Section} from '../../components/ui/Section';
import {SectionHeader} from '../../components/ui/SectionHeader';

export function PrivacyPage() {
  return (
    <LandingLayout>
      <Section padding="lg" background="white" className="pt-32 bg-background dark:bg-[#1E1E1E]">
        <Container className="max-w-4xl">
          <SectionHeader
            title="Privacy Policy"
            subtitle={`Last updated: ${new Date().toLocaleDateString()}`}
            centered
            size="lg"
          />

          <div className="prose prose-lg max-w-none text-textSecondary dark:text-[#858585] space-y-8">
            <section>
              <h2 className="text-2xl font-semibold text-textPrimary dark:text-[#CCCCCC] mb-4">Introduction</h2>
              <p>
                At VoxaPilot, we take your privacy seriously. This Privacy Policy explains how we
                collect, use, disclose, and safeguard your information when you use our service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-textPrimary dark:text-[#CCCCCC] mb-4">
                Information We Collect
              </h2>
              <h3 className="text-xl font-semibold text-textPrimary dark:text-[#CCCCCC] mb-3">Information You Provide</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Account information (name, email address)</li>
                <li>Meeting recordings and transcriptions</li>
                <li>Profile information and preferences</li>
                <li>Payment information (processed securely through third-party providers)</li>
              </ul>

              <h3 className="text-xl font-semibold text-textPrimary mb-3 mt-6">
                Information We Collect Automatically
              </h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Usage data and analytics</li>
                <li>Device information and IP address</li>
                <li>Cookies and similar tracking technologies</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-textPrimary dark:text-[#CCCCCC] mb-4">How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Provide, maintain, and improve our services</li>
                <li>Process transactions and send related information</li>
                <li>Send technical notices and support messages</li>
                <li>Respond to your comments and questions</li>
                <li>Monitor and analyze usage patterns</li>
                <li>Detect, prevent, and address technical issues</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-textPrimary dark:text-[#CCCCCC] mb-4">Data Security</h2>
              <p>
                We implement appropriate technical and organizational measures to protect your
                personal information. This includes encryption, access controls, and regular security
                audits. However, no method of transmission over the Internet is 100% secure.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-textPrimary dark:text-[#CCCCCC] mb-4">Data Retention</h2>
              <p>
                We retain your personal information for as long as necessary to provide our services
                and fulfill the purposes described in this policy. You can request deletion of your
                data at any time.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-textPrimary dark:text-[#CCCCCC] mb-4">Your Rights</h2>
              <p>You have the right to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Access your personal information</li>
                <li>Correct inaccurate data</li>
                <li>Request deletion of your data</li>
                <li>Object to processing of your data</li>
                <li>Data portability</li>
                <li>Withdraw consent at any time</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-textPrimary dark:text-[#CCCCCC] mb-4">Third-Party Services</h2>
              <p>
                We may use third-party services to help us operate our service. These services have
                access to your information only to perform specific tasks and are obligated not to
                disclose or use it for any other purpose.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-textPrimary dark:text-[#CCCCCC] mb-4">Changes to This Policy</h2>
              <p>
                We may update this Privacy Policy from time to time. We will notify you of any
                changes by posting the new policy on this page and updating the "Last updated" date.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-textPrimary dark:text-[#CCCCCC] mb-4">Contact Us</h2>
              <p>
                If you have questions about this Privacy Policy, please contact us at:{' '}
                <a href="mailto:privacy@voxapilot.com" className="text-accent dark:text-orange-500 hover:underline">
                  privacy@voxapilot.com
                </a>
              </p>
            </section>
          </div>
        </Container>
      </Section>
    </LandingLayout>
  );
}

